import { useEffect } from 'react';

import { useIsAuth } from '#modules/user/features/auth/hooks/useIsAuth';
import { onNativeAuthReady } from '#features/api/utils/nativeAuth';
import {
  isNativeCallEnabled,
  subscribeNativeCalls,
  syncNativeCallAuth,
} from '#features/calls/utils/nativeCalls';
import { useVoiceStore } from '#features/voice/model/voiceStore';

/** Observe the process-owned call; rebuilding or hiding WebView cannot end its media. */
export const useIOSNativeCallBridge = (): void => {
  const isAuth = useIsAuth();
  const voiceSessionId = useVoiceStore((state) => state.room?.sessionId ?? null);
  useEffect(() => {
    if (!isNativeCallEnabled()) return;
    let disposed = false;
    let off: (() => void) | undefined;
    void subscribeNativeCalls()
      .then((remove) => {
        if (disposed) remove();
        else off = remove;
        return undefined;
      })
      .catch(() => undefined);
    const offAuth = onNativeAuthReady(() => {
      void syncNativeCallAuth().catch(() => undefined);
    });
    return () => {
      disposed = true;
      off?.();
      offAuth();
    };
  }, []);

  useEffect(() => {
    if (isNativeCallEnabled() && isAuth) {
      void syncNativeCallAuth(voiceSessionId).catch(() => undefined);
    }
  }, [isAuth, voiceSessionId]);
};
